var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDuplicateHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/duplicate/hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.64705882,11.4705882 L4.94117647,11.4705882 L4.94117647,5.35294118 C4.94117647,5.09411765 4.72941176,4.88235294 4.47058824,4.88235294 L4.47058824,4.88235294 C4.21176471,4.88235294 4,5.09411765 4,5.35294118 L4,11.4705882 C4,11.9882353 4.42352941,12.4117647 4.94117647,12.4117647 L9.64705882,12.4117647 C9.90588235,12.4117647 10.1176471,12.2 10.1176471,11.9411765 L10.1176471,11.9411765 C10.1176471,11.6823529 9.90588235,11.4705882 9.64705882,11.4705882 Z M12,9.58823529 L12,3.94117647 C12,3.42352941 11.5764706,3 11.0588235,3 L6.82352941,3 C6.30588235,3 5.88235294,3.42352941 5.88235294,3.94117647 L5.88235294,9.58823529 C5.88235294,10.1058824 6.30588235,10.5294118 6.82352941,10.5294118 L11.0588235,10.5294118 C11.5764706,10.5294118 12,10.1058824 12,9.58823529 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/duplicate/hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-placer",
    transform: "translate(-1.000000, 0.000000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/duplicate/normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-placer",
    fill: "#5697B7",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#5697B7",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#5697B7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuplicateHover);
export default __webpack_public_path__ + "static/media/icon_duplicate_hover.95d9329ad728cd0f0254849a41e3b22c.svg";
export { ForwardRef as ReactComponent };